import React, { useEffect, useState } from "react";
import ApiClient from "../../utils/ApiClient";
import ConfirmationModal from "./ConfirmationModal";

export default function CreateNewPackingList({ poSelected }) {
    const [poData, setPoData] = useState([]); // State to hold fetched data
    const [inputStatus, setInputStatus] = useState({}); // State to track input save status
    const [packingListQuantities, setPackingListQuantities] = useState({}); // State to hold input values
    const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
    const [isPackingListCreated, setIsPackingListCreated] = useState(false); // State to track if packing list is created

    useEffect(() => {
        console.log("getpodata - create new packing list");
        console.log(poSelected)
        if (poSelected) {
            ApiClient.post("/api/receiveinventory/getpodata", {
                poNumber: poSelected,
            })
                .then((response) => {
                    console.log("PO Data- create new packing list:", response.data);
                    setPoData(response.data); // Set fetched data to state
                    setInputStatus(
                        response.data.reduce((acc, item) => {
                            acc[item.id] = "saved"; // Set initial status to "saved"
                            return acc;
                        }, {})
                    );
                    setPackingListQuantities(
                        response.data.reduce((acc, item) => {
                            acc[item.id] = item.packingListQty || ""; // Initialize with current quantities or empty
                            return acc;
                        }, {})
                    );
                })
                .catch((error) => {
                    console.error("Failed to fetch PO data", error);
                });
        }
    }, [poSelected]); // Dependency ensures the effect re-runs when poSelected changes

    const handleQtyChange = (value, itemId) => {
        setPackingListQuantities((prev) => ({
            ...prev,
            [itemId]: value,
        }));
        setInputStatus((prev) => ({
            ...prev,
            [itemId]: "unsaved",
        }));
    };

    const handleSavePackingList = () => {
        ApiClient.post("/api/receiveinventory/createnewpackinglist", {
            poNumber: poSelected,
            packingList: packingListQuantities,
        })
            .then((response) => {
                console.log("Response:", response.data);
                if (response.data === 1) {
                    console.log("Packing list saved:", response.data);
                    setInputStatus(
                        Object.keys(packingListQuantities).reduce((acc, itemId) => {
                            acc[itemId] = "saved"; // Mark all as saved
                            return acc;
                        }, {})
                    );
                    setIsPackingListCreated(true); // Set packing list as created
                    setIsModalOpen(true); // Open the modal

                } else {
                    console.error("Failed to save packing list");
                }
            })
            .catch((error) => {
                console.error("Failed to save packing list", error);
            });
    };

    const closeModal = () => {
        setIsModalOpen(false); // Close the modal
    };

    return (
        <div className="px-4 sm:px-6 lg:px-8">
            {/* ConfirmationModal */}
            {isModalOpen && (
                <ConfirmationModal
                    title="Success"
                    message="Packing list has been saved successfully."
                    onClose={closeModal}
                />
            )}
            {!isPackingListCreated ? (
                <div>
                    <div className="sm:flex sm:items-center">
                        <div className="sm:flex-auto">
                            <h1 className="text-base font-semibold text-gray-900">Purchase Orders</h1>
                            <p className="mt-2 text-sm text-gray-700">
                                A list of all the products in the selected PO, including their details such as GTIN, SKU, and quantities.
                            </p>
                        </div>
                        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                            <button
                                type="button"
                                onClick={handleSavePackingList}
                                className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Save Packing List
                            </button>
                        </div>
                    </div>
                    <div className="mt-8 flow-root">
                        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                <table className="min-w-full divide-y divide-gray-300">
                                    <thead>
                                    <tr>
                                        <th className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-3 w-1">
                                            PO <br /> Number
                                        </th>
                                        <th className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1">
                                            GTIN
                                        </th>
                                        <th className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1">
                                            Supplier SKU
                                        </th>
                                        <th
                                            className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
                                            style={{ wordWrap: "break-word", maxWidth: "200px" }}
                                        >
                                            Product Name
                                        </th>
                                        <th className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1 whitespace-normal break-words">
                                            Ordered <br /> Qty
                                        </th>
                                        <th className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1 whitespace-normal break-words">
                                            Packing List <br /> Qty
                                        </th>
                                        <th className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1 whitespace-normal break-words">
                                            All Packing <br /> List Qty
                                        </th>
                                        <th className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1 whitespace-normal break-words">
                                            Remaining <br /> Qty
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white">
                                    {poData.length > 0 ? (
                                        poData.map((item, index) => (
                                            <tr key={index} className={index % 2 === 0 ? "even:bg-gray-50" : "bg-white"}>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3">
                                                    {item.poNumber}
                                                </td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item.gtin}</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item.supplier_sku}</td>
                                                <td
                                                    className="whitespace-normal break-words px-3 py-4 text-sm text-gray-500 max-w-xs"
                                                    style={{ wordWrap: "break-word", maxWidth: "200px" }}
                                                >
                                                    {item.product_name}
                                                </td>
                                                <td className="px-3 py-4 text-center text-sm text-gray-500 whitespace-normal break-words w-1">
                                                    {item.qty_ordered}
                                                </td>
                                                <td className="px-3 py-4 text-center text-sm text-gray-500 whitespace-normal break-words w-1">
                                                    <input
                                                        type="number"
                                                        value={packingListQuantities[item.id] || ""}
                                                        onChange={(e) => handleQtyChange(e.target.value, item.id)}
                                                        className={`border rounded-md px-2 py-1 w-20 text-center ${
                                                            inputStatus[item.id] === "unsaved"
                                                                ? "border-red-500"
                                                                : inputStatus[item.id] === "saved"
                                                                    ? "border-green-500"
                                                                    : "border-gray-300"
                                                        }`}
                                                    />
                                                </td>
                                                <td className="px-3 py-4 text-center text-sm text-gray-500 whitespace-normal break-words w-1">
                                                    0
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={7} className="px-3 py-4 text-sm text-gray-500 text-center">
                                                No data available for the selected PO.
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-center py-10 text-lg text-gray-700 font-semibold">
                    Packing list created.
                </div>
            )}
        </div>
    );
}
